import api from './api'; 

class NotificationService {
  
  // Get current escalation settings
  static async getComplianceSettings() {
    try {
      const response = await api.get('/notifications/compliance-escalation');
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance settings:', error);
      throw error;
    }
  }

  // Save/Update settings
  static async saveComplianceSettings(payload) {
    try {
      const response = await api.put('/notifications/compliance-escalation', payload);
      return response.data;
    } catch (error) {
      console.error('Error saving compliance settings:', error);
      throw error;
    }
  }

  // Manually trigger the daily job (for testing)
  static async triggerComplianceJob() {
    try {
      const response = await api.post('/notifications/jobs/trigger-compliance');
      return response.data;
    } catch (error) {
      console.error('Error triggering compliance job:', error);
      throw error;
    }
  }
}

export default NotificationService;